/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { access_AccessModuleResponse } from '../models/access_AccessModuleResponse';
import type { access_AccessRoleEmployeeResponse } from '../models/access_AccessRoleEmployeeResponse';
import type { access_AccessRoleResponse } from '../models/access_AccessRoleResponse';
import type { access_CreateAccessRoleRequest } from '../models/access_CreateAccessRoleRequest';
import type { access_RenameAccessRoleRequest } from '../models/access_RenameAccessRoleRequest';
import type { access_ReplaceAccessRoleModulesRequest } from '../models/access_ReplaceAccessRoleModulesRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AccessRolesService {
    /**
     * List access roles
     * Lists every professional role of the organisation (active and inactive) with its module grants and the number of employees whose contract covering today carries it. Seeds the default grants on first use. Admin only.
     * @returns access_AccessRoleResponse OK
     * @throws ApiError
     */
    public static getApiV1AccessRoles(): CancelablePromise<Array<access_AccessRoleResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/access-roles',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create an access role
     * Creates an organisation-level professional role. With copyFrom the new role copies that role's grants in the same transaction. Admin only.
     * @param request New role
     * @returns access_AccessRoleResponse Created
     * @throws ApiError
     */
    public static postApiV1AccessRoles(
        request: access_CreateAccessRoleRequest,
    ): CancelablePromise<access_AccessRoleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/access-roles',
            body: request,
            errors: {
                400: `Validation failed or invalid copy source`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Deactivate an access role
     * Deactivates a role (never deletes it). A role that an employee's contract covering today carries cannot be deactivated. Admin only.
     * @param value Role value
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1AccessRoles(
        value: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/access-roles/{value}',
            path: {
                'value': value,
            },
            errors: {
                400: `Validation failed`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Access role not found`,
                409: `Access role in use`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Rename an access role
     * Changes the label of a role. A system role gets an organisation-level override. Admin only.
     * @param value Role value
     * @param request New label
     * @returns access_AccessRoleResponse OK
     * @throws ApiError
     */
    public static patchApiV1AccessRoles(
        value: string,
        request: access_RenameAccessRoleRequest,
    ): CancelablePromise<access_AccessRoleResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/access-roles/{value}',
            path: {
                'value': value,
            },
            body: request,
            errors: {
                400: `Validation failed`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Access role not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List the employees of an access role
     * Lists the employees whose work contract covering today carries the role -- the employees behind employeeCount -- ordered by last name. Admin only.
     * @param value Role value
     * @returns access_AccessRoleEmployeeResponse OK
     * @throws ApiError
     */
    public static getApiV1AccessRolesEmployees(
        value: string,
    ): CancelablePromise<Array<access_AccessRoleEmployeeResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/access-roles/{value}/employees',
            path: {
                'value': value,
            },
            errors: {
                400: `Invalid role value`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Access role not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Replace the module grants of a role
     * Sets the grants of the role to exactly the given modules; an empty list removes every grant. The change is live on the next request. Admin only.
     * @param value Role value
     * @param request New grant set
     * @returns access_AccessRoleResponse OK
     * @throws ApiError
     */
    public static putApiV1AccessRolesModules(
        value: string,
        request: access_ReplaceAccessRoleModulesRequest,
    ): CancelablePromise<access_AccessRoleResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/access-roles/{value}/modules',
            path: {
                'value': value,
            },
            body: request,
            errors: {
                400: `Validation failed or unknown module`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Access role not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List the module catalog
     * Returns the grantable modules in catalog order. Labels are client i18n. Admin only.
     * @returns access_AccessModuleResponse OK
     * @throws ApiError
     */
    public static getApiV1AccessRolesModules(): CancelablePromise<Array<access_AccessModuleResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/access-roles/modules',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
